import styled from 'styled-components';

export const AnalyseProgressWrapper = styled.div`
  & .progress-title {
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 10px;
  }

  & .progress-wrapper {
    position: relative;

    & ion-progress-bar {
      height: 46px;
      --background: #90d5e8;
      --progress-background: #21abd2;

      &::part(track) {
        background: #90d5e8;
      }
    }

    & .progress-value {
      position: absolute;
      z-index: 10;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
    }
  }
`;
